export function getStatusColor(status) {
    switch (status) {
        case 'failed':
            return 'danger';
        case 'completed':
            return 'success';
        case 'running':
            return 'warning';
        case 'pending':
            return 'secondary';
        default:
            return 'default';
    }
}
//# sourceMappingURL=color.js.map